export default __webpack_public_path__ + "static/media/7.f8a0e1c0.png";